import DataTables from "datatables.net-dt";
import initDataTablesBootstrap from "./vendor/dataTables.bootstrap.js";
import i18n from "./lib/i18n.js";

export default function (jQuery) {
  DataTables(window, jQuery);

  initDataTablesBootstrap(jQuery);

  const initializeDataTable = () => {
    const sortWithIntl = () => {
      $.fn.dataTable.ext.order.intl = function (locales, options) {
        if (window.Intl) {
          var collator = new window.Intl.Collator(locales, options);
          var types = $.fn.dataTable.ext.type;

          delete types.order["string-pre"];
          types.order["string-asc"] = collator.compare;
          types.order["string-desc"] = function (a, b) {
            return collator.compare(a, b) * -1;
          };
        }
      };

      $.fn.dataTable.ext.order.intl(i18n.locale);
    };

    const destroyDetachedDataTables = () => {
      $.fn.dataTable
        .tables()
        .filter((table) => !document.body.contains(table))
        .forEach((table) => $(table).DataTable().destroy());
    };

    const initUninitializedTables = (selector, options) => {
      $(selector)
        .filter((_, table) => !$.fn.dataTable.isDataTable(table))
        .dataTable(options);
    };

    const initDataTables = () => {
      destroyDetachedDataTables();
      initDefaultTable();
      initSimpleTable();
    };

    const showTables = () => {
      document
        .querySelectorAll(".dataTable, .dataTable-simple")
        .forEach((table) => {
          table.style.visibility = "visible";
        });
    };

    const initDefaultTable = () => {
      // DataTables adds the dataTable class to every table it initializes,
      // so simple tables match .dataTable once initialized
      initUninitializedTables(".dataTable:not(.dataTable-simple)", {
        oLanguage: dtLocale,
        bSearch: true,
        bInfo: true,
        bFilter: true,
        bLengthChange: true,
        stateSave: true,
        initComplete: showTables,
      });
    };

    const initSimpleTable = () => {
      initUninitializedTables(".dataTable-simple", {
        oLanguage: dtLocale,
        sDom: "flrtip",
        bSearch: true,
        bInfo: true,
        bFilter: true,
        iDisplayLength: 10,
        bLengthChange: false,
        stateSave: false,
        initComplete: function () {
          updateSearchBarLayout.apply(this, arguments);
          showTables();
        },
      });
    };

    const updateSearchBarLayout = function (settings) {
      const wrapper = settings.nTableWrapper;
      const table = wrapper.querySelector("table");

      // Fix styling of search input
      wrapper.classList.remove("form-inline");
      const input = wrapper.querySelector("input.form-control");

      const inputGroup = document.createElement("div");

      inputGroup.className = "input-group col-lg-6 col-md-6 col-sm-12";
      const inputGroupAddon = document.createElement("div");
      inputGroupAddon.classList.add("input-group-addon");
      const icon = document.createElement("i");
      icon.classList.add("fa");
      icon.classList.add("fa-search");
      inputGroupAddon.appendChild(icon);
      inputGroup.appendChild(inputGroupAddon);

      inputGroup.appendChild(input);
      input.placeholder = "Sök...";

      wrapper.querySelector(".dataTables_filter").appendChild(inputGroup);
      const label = wrapper.querySelector(".dataTables_filter label");
      wrapper.querySelector(".dataTables_filter").removeChild(label);

      wrapper.querySelector(".dataTables_filter").classList.add("mb-16");
      const actionButtonWrapper = document.createElement("div");
      const actionButton = document.querySelector("#action_btn");
      if (table.dataset.hasAction == "true" && actionButton) {
        actionButtonWrapper.appendChild(actionButton);
        wrapper
          .querySelector(".dataTables_filter")
          .appendChild(actionButtonWrapper);
        wrapper
          .querySelector(".dataTables_filter")
          .classList.add("flex", "flex-jc-spb", "gap-24", "align-items-center");
      }

      // Fix styling of pagination and row info
      if (table.classList.contains("dataTable-simple")) {
        const footerWrapper = document.createElement("div");
        footerWrapper.style =
          "display: flex; justify-content: space-between; align-items: center;";
        footerWrapper.appendChild(wrapper.querySelector(".dataTables_info"));
        footerWrapper.appendChild(
          wrapper.querySelector(".dataTables_paginate")
        );
        wrapper.appendChild(footerWrapper);
      }

      // Set length if data attribute exists
      if (table.dataset.pageLength) {
        const api = $(table).DataTable();
        api.page.len(table.dataset.pageLength).draw();
      }
    };

    const dtLocale = {
      sEmptyTable: i18n.t("js.data_tables.empty_table"),
      sInfo: i18n.t("js.data_tables.info"),
      sInfoEmpty: i18n.t("js.data_tables.info_empty"),
      sInfoFiltered: i18n.t("js.data_tables.info_filtered"),
      sInfoPostFix: "",
      sInfoThousands: ",",
      sLengthMenu: i18n.t("js.data_tables.length_menu"),
      sLoadingRecords: i18n.t("js.data_tables.loading_records"),
      sProcessing: i18n.t("js.data_tables.processing"),
      sSearch: i18n.t("js.data_tables.search"),
      sZeroRecords: i18n.t("js.data_tables.zero_records"),
      oPaginate: {
        sFirst: i18n.t("js.data_tables.paginate.first"),
        sLast: i18n.t("js.data_tables.paginate.last"),
        sNext: i18n.t("js.data_tables.paginate.next"),
        sPrevious: i18n.t("js.data_tables.paginate.previous"),
      },
      oAria: {
        sSortAscending: i18n.t("js.data_tables.aria.sort_ascending"),
        sSortDescending: i18n.t("js.data_tables.aria.sort_descending"),
      },
    };

    sortWithIntl();
    initDataTables();
  };

  document.addEventListener("DOMContentLoaded", () => {
    initializeDataTable();
  });

  document.addEventListener("turbo:frame-load", () => {
    initializeDataTable();
  });
}
